import { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import IEmailCampaign from "./types/IEmailCampaign";
import SendCampaignModal from "./components/SendCampaignModal";

const EmailDashboard = () => {
  const history = useHistory();
  const [campaigns, setCampaigns] = useState<IEmailCampaign[]>([]);
  const [loading, setLoading] = useState(true);
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState<IEmailCampaign | null>(null);

  const fetchCampaigns = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/v1/company/outreach/email-campaigns`);
      setCampaigns(response.data);
    } catch (error) {
      console.error("Error fetching campaigns:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const onClickNewCampaign = () => {
    history.push("/outreach/email/new");
  };

  const onClickViewCampaign = (campaignId: number) => {
    history.push(`/outreach/email/${campaignId}`);
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {/* Quick Actions */}
      <div className="mb-6 flex flex-wrap gap-4 flex-row justify-between items-center">
        <h1 className="text-3xl font-bold mb-4 text-gray-800">Email Dashboard</h1>

        <button className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600" onClick={onClickNewCampaign}>
          + New Campaign
        </button>
      </div>

      {/* Campaign List */}
      <div className="bg-white shadow rounded-lg p-4">
        <h2 className="text-xl font-semibold mb-4 text-gray-700">Recent Campaigns</h2>

        {loading ? (
          <p className="text-gray-600">Loading campaigns...</p>
        ) : campaigns.length === 0 ? (
          <p className="text-gray-600">No campaigns found.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full table-auto border-collapse">
              <thead>
                <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                  <th className="py-3 px-6 text-left">Name</th>
                  <th className="py-3 px-6 text-left">Subject</th>
                  <th className="py-3 px-6 text-left">Created</th>
                  <th className="py-3 px-6 text-center">Send On</th>
                  <th className="py-3 px-6 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {campaigns.map((campaign) => (
                  <tr key={campaign.id} className="border-b hover:bg-gray-100 text-gray-700">
                    <td className="py-3 px-6 text-left">{campaign.name}</td>
                    <td className="py-3 px-6 text-left">{campaign.subject}</td>
                    <td className="py-3 px-6 text-left">{new Date(campaign.created_at).toLocaleDateString()}</td>
                    <td className="py-3 px-6 text-center">{campaign.send_date ? new Date(campaign.send_date).toLocaleDateString() : "-"}</td>
                    <td className="py-3 px-6 text-center flex justify-center space-x-4">
                      <button className="text-blue-500 hover:underline" onClick={() => onClickViewCampaign(campaign.id)}>
                        View
                      </button>
                      <button className="text-green-500 hover:underline" onClick={() => {
                        setSelectedCampaign(campaign);
                        setIsSendModalOpen(true);
                      }}>
                        Send
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Send Campaign Modal */}
      {isSendModalOpen && selectedCampaign && (
        <SendCampaignModal isOpen={isSendModalOpen} onClose={() => setIsSendModalOpen(false)} campaign={selectedCampaign} />
      )}
    </div>
  );
};

export default EmailDashboard;
